// src/hr/portal/WhosOutPage.js -- HR's Who's Out (mockup screen 4): the same month calendar everyone
// sees, from GET /api/hr/whos-out. It shows "Out" only, never the type (spec §8.3); HR sees types on a
// person's profile and in the Who's out report, which the header links to.
import React from 'react';
import { Link } from 'react-router-dom';
import { FiBarChart2 } from 'react-icons/fi';
import { Card } from '../kit';
import WhosOutCalendar from '../WhosOutCalendar';

export function WhosOutPage({ today }) {
  return (
    <div className="hrp-page hrp-wop">
      <div className="hrp-page-head">
        <div>
          <h1 className="hrp-h1">Who's Out</h1>
          <p className="hrp-sub">Approved time off and sick days, Monday to Friday. Everyone sees the same view.</p>
        </div>
        <div className="hrp-page-head__acts">
          <Link to="../reports?report=whos-out" className="hrp-btn hrp-btn--ghost hrp-btn--md">
            <span className="hrp-btn__ic" aria-hidden="true"><FiBarChart2 /></span>
            <span className="hrp-btn__label">Report with types</span>
          </Link>
        </div>
      </div>
      <Card delay={0} className="hrp-calcard">
        <WhosOutCalendar mode="month" today={today} />
      </Card>
    </div>
  );
}

export default WhosOutPage;
